import * as msal from "@azure/msal-browser";
import { RedirectRequest } from "@azure/msal-browser";

const hostname = window.location.hostname;
const isLocalhost = hostname.includes("localhost");

const cli = import.meta.env.VITE_CLIENT_ID;
const auth = import.meta.env.VITE_AUTHORITY;

const rUri = isLocalhost
	? "http://localhost:5173/private/home"
	: import.meta.env.VITE_REDIRECT_URI;

const siteUri = isLocalhost
	? "http://localhost:5173/public/home"
	: import.meta.env.VITE_SITE_URL;
const known = [
	import.meta.env.VITE_KNOWN_AUTHORITIES.replace(/^https?:\/\//, ""),
];
const scopesArray = import.meta.env.VITE_SCOPES.split(" ");

const msalConfig: msal.Configuration = {
	auth: {
		clientId: cli,
		authority: auth,
		redirectUri: rUri,
		knownAuthorities: known,
	},
	cache: {
		cacheLocation: "sessionStorage",
	},
};

const loginRequest: RedirectRequest = {
	scopes: scopesArray,
};

const msalInstance = new msal.PublicClientApplication(msalConfig);

export const initialiseMsal = async () => {
  await msalInstance.initialize();

  try {
    const response = await msalInstance.handleRedirectPromise();

    if (response?.account) {
      msalInstance.setActiveAccount(response.account);
      return response.account;
    }

    const activeAccount = msalInstance.getActiveAccount();

    if (activeAccount) {
      return activeAccount;
    }

    const accounts = msalInstance.getAllAccounts();

    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
      return accounts[0];
    }

    return null;
  } catch (error) {
    console.error("MSAL redirect handling failed:", error);
    return null;
  }
};

export const getCurrentAccount = () => {
  return (
    msalInstance.getActiveAccount() ??
    msalInstance.getAllAccounts()[0] ??
    null
  );
};

export const baseurl = import.meta.env.VITE_BASE_URL;
export const dataMigrationBaseUrl = import.meta.env.VITE_AURIGA_URL;
export const dcsbaseurl = import.meta.env.VITE_DCS_URL;
export const orionbaseurl = import.meta.env.VITE_ORION_URL;

export const scopes = scopesArray;
export const siteurl = siteUri;

export { msalInstance, loginRequest };
